import React, { useState } from "react";
import { toast } from "sonner";
import { api, getUser } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import PageHeader from "../components/PageHeader";

export default function Conta() {
  const me = getUser();
  const [form, setForm] = useState({ old_password: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error("As passwords não coincidem");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { old_password: form.old_password, new_password: form.new_password });
      toast.success("Password alterada com sucesso");
      setForm({ old_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="conta-page">
      <PageHeader title="A Minha Conta" subtitle={`${me?.name} · ${me?.email}`} testid="conta-header" />
      <form onSubmit={submit} className="a4w-card p-6 max-w-md space-y-4">
        <h3 className="text-lg font-semibold">Alterar Password</h3>
        <div><Label>Password Atual</Label><Input type="password" required value={form.old_password} onChange={(e) => setForm({ ...form, old_password: e.target.value })} data-testid="conta-old" /></div>
        <div><Label>Nova Password</Label><Input type="password" required value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="conta-new" /></div>
        <div><Label>Confirmar Nova Password</Label><Input type="password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="conta-confirm" /></div>
        <Button type="submit" disabled={loading} className="bg-[#1E3A8A] hover:bg-[#172554]" data-testid="conta-save">Alterar Password</Button>
      </form>
    </div>
  );
}
